import { Box, Shimmer, ShimmerText } from '@betterment/samba-react';

import YtdListItem from '../../../FourOhOneKDeferralSettings/components/YtdListItem';
import { currentYear } from '../../../FourOhOneKDeferralSettings/models';

export const DeferralProjectionLoading: React.FC = () => {
  return (
    <>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.50', mb: 'space.100' }}>
        <Shimmer css={{ height: '16px', width: '100%' }} />
        <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
          <ShimmerText textStyle="text25" css={{ width: '50px' }} />
          <Shimmer css={{ height: '12px', width: '100px' }} />
        </Box>
      </Box>

      <YtdListItem bullet="bmtVizNavy" leadingTitle="Year-to-date contributions" loading={true} />
      <YtdListItem bullet="bmtVizBlue50" leadingTitle="Projected contributions" loading={true} />
      <YtdListItem leadingTitle={`Total 401(k) contributions for ${currentYear()}`} strong={true} loading={true} />
    </>
  );
};
